<template>
  <h3>{{ title }}</h3>
</template>

<script>
export default {
  props: ["title"],
};
</script>

<style scoped lang="scss">
h3 {
  color: #23263a !important;
  font-weight: 700;
  font-size: 1.45rem;
  letter-spacing: 0.2px;
}
</style>